import { gql, useMutation } from '@apollo/client'
import type {
  PotentialProfileSuggestionMutation,
  PotentialProfileSuggestionMutationVariables,
} from 'apollo-gql'
import { currentMarketIdVar } from 'graphql/reactive'

type MutationFunction = (
  input: PotentialProfileSuggestionMutationVariables['input'],
) => Promise<void>

type UsePotentialProfileSuggestion = (options?: {
  onCompleted?: (
    data: PotentialProfileSuggestionMutation['market']['suggestPotentialProfile'],
  ) => void
}) => [MutationFunction, { loading: boolean }]

const mutation = gql`
  mutation PotentialProfileSuggestion(
    $marketId: ID!
    $input: PotentialProfileSuggestionInput!
  ) {
    market(id: $marketId) {
      suggestPotentialProfile(input: $input) {
        potentialProfileSuggestion {
          id
          name
          description
        }
        errors {
          identifier
          message
          field
        }
        result
      }
    }
  }
`

const usePotentialProfileSuggestion: UsePotentialProfileSuggestion = ({
  onCompleted,
} = {}) => {
  const marketId = currentMarketIdVar()

  const [mutate, { loading }] = useMutation(mutation, {
    onCompleted: (res: PotentialProfileSuggestionMutation) => {
      if (onCompleted) {
        onCompleted(res.market.suggestPotentialProfile)
      }
    },
  })

  const potentialProfileSuggestion: MutationFunction = async (input) => {
    if (!input) throw new Error('input is required')

    await mutate({
      variables: {
        marketId,
        input,
      },
    })
  }

  return [potentialProfileSuggestion, { loading }]
}

export default usePotentialProfileSuggestion
